import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import './MainPages.scss';
import Header from 'layouts/header';
import { useAppDispatch } from 'store/store';
import { asyncFetchSessionUser } from 'store/reducers/users/thunks';

function MainPages(): React.ReactElement {
    const dispatch = useAppDispatch();
    React.useEffect(() => {
        dispatch(asyncFetchSessionUser());
    }, [dispatch]);
    const navigate = useNavigate();
    React.useEffect(() => {
        if (!localStorage.token) navigate('/login');
    }, [navigate]);

    return (
        <>
            <Header />
            <main>
                <Outlet />
            </main>
        </>
    );
}

export default React.memo(MainPages);
